(function(){
  const SECTION_ID = '{{ section.id }}';
  let onResize = null;

  function handleProductGridBanner() {
    const grid = document.getElementById('product-grid');
    if (!grid) return;

    const banner = grid.querySelector('.banner-item');
    if (!banner) return;

    // Se il banner non ha immagine, rimuovilo
    if (!banner.querySelector('img')) {
      banner.remove();
      grid.classList.remove('has-banner');
      return;
    }

    grid.classList.add('has-banner');
    grid.style.opacity = '1';
    grid.style.visibility = 'visible';

    const reposition = () => {
      const products = Array.from(grid.children).filter(el => el.classList.contains('product-item'));
      const after = Math.min(3, products.length - 1);
      if (window.innerWidth < 990) {
        products[after]?.after(banner);
      } else {
        grid.append(banner);
      }
    };

    reposition();
    onResize = () => reposition();
    window.addEventListener('resize', onResize, { passive: true });
  }

  // init solo per questa sezione
  document.addEventListener('DOMContentLoaded', handleProductGridBanner);
  document.addEventListener('shopify:section:load', e => {
    if (e.detail?.sectionId === SECTION_ID) handleProductGridBanner();
  });
  document.addEventListener('shopify:section:unload', e => {
    if (e.detail?.sectionId === SECTION_ID && onResize) {
      window.removeEventListener('resize', onResize);
      onResize = null;
    }
  });
})();